import React from 'react';

import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { PaginationItem, Typography } from '@mui/material';
import Pagination from '@mui/material/Pagination';
import { SxProps, Theme } from '@mui/system';
import './PaginationControlLight.scss';

type Props = {
  count: number;
  onChange:
    | ((event: React.ChangeEvent<unknown>, page: number) => void)
    | undefined;
  page: number;
  siblingCount?: number;
  boundaryCount?: number;
  sx?: SxProps<Theme>;
  disabled?: boolean;
  onMouseEnter?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
};

const PaginationControlLight: React.FC<Props> = ({
  count,
  onChange,
  page,
  siblingCount = 1,
  boundaryCount = 1,
  sx,
  disabled = false,
  onMouseEnter,
}) => {
  return (
    <Pagination
      sx={{
        'ul > li:first-of-type > button:disabled > p, ul > li:last-of-type > button:disabled > p':
          {
            color: 'black',
          },
        ...sx,
      }}
      count={count}
      variant='text'
      shape='rounded'
      size='small'
      color='translucentPrimary'
      onChange={onChange}
      page={page}
      siblingCount={siblingCount}
      boundaryCount={boundaryCount}
      disabled={disabled}
      onMouseEnter={onMouseEnter}
      renderItem={(item) => (
        <PaginationItem
          components={{
            previous: () => (
              <Typography
                color='primary'
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'center',
                  mr: '12px',
                }}
              >
                <ChevronLeftIcon />
                Previous
              </Typography>
            ),
            next: () => (
              <Typography
                color='primary'
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'center',
                  ml: '12px',
                }}
              >
                Next
                <ChevronRightIcon />
              </Typography>
            ),
          }}
          {...item}
        />
      )}
    />
  );
};

export default PaginationControlLight;
